function AlertIcon({ size = '42', styles = {}, color = '#959FAF' }) {
  return (
    <svg
      style={{ ...styles }}
      width={size}
      height={size}
      viewBox="0 0 42 42"
      fill="none"
    >
      <circle cx="21" cy="21" r="20" stroke={color} strokeWidth="2" />
      <path
        d="M21.8401 13.92C22.5036 13.92 23.04 14.4564 23.04 15.1199V22.3194C23.04 22.9829 22.5036 23.5193 21.8401 23.5193C21.1766 23.5193 20.6402 22.9817 20.6402 22.3194V15.1199C20.6402 14.4564 21.1765 13.92 21.8401 13.92Z"
        fill={color}
      />
      <path
        d="M20.7374 26.7818C20.7974 26.6258 20.8814 26.4938 20.9894 26.3859C21.0494 26.3379 21.1094 26.2779 21.1813 26.2419C21.2413 26.1939 21.3133 26.1591 21.3853 26.1339C21.4574 26.0967 21.5293 26.0739 21.6133 26.0619C21.9961 25.9779 22.4173 26.111 22.692 26.3859C22.8001 26.4938 22.884 26.6259 22.944 26.7818C23.004 26.9258 23.04 27.0818 23.04 27.2378C23.04 27.3938 23.004 27.5498 22.944 27.6938C22.8841 27.8378 22.8001 27.9698 22.692 28.0898C22.572 28.1977 22.4401 28.2817 22.2961 28.3417C22.1521 28.4017 21.9961 28.4377 21.8401 28.4377C21.6841 28.4377 21.5293 28.4017 21.3853 28.3417C21.2414 28.2818 21.1106 28.1978 20.9894 28.0898C20.8814 27.9698 20.7974 27.8378 20.7374 27.6938C20.6774 27.5498 20.6414 27.3938 20.6414 27.2378C20.6414 27.0818 20.6774 26.9258 20.7374 26.7818Z"
        fill={color}
      />
    </svg>
  );
}

export default AlertIcon;
